import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getTournaments,
  exportTournaments,
} from "../../api/admin/tournaments.api";

/* =============================================================
   🚀 FETCH TOURNAMENTS (CACHED + OPTIMIZED)
============================================================= */
export const fetchTournaments = createAsyncThunk(
  "admin/tournaments/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getTournaments();

      if (!res?.success) {
        return rejectWithValue(
          res?.message || "Failed to fetch tournaments"
        );
      }

      return Array.isArray(res.data) ? res.data : [];
    } catch (error) {
      return rejectWithValue(
        error?.message || "Unexpected error occurred"
      );
    }
  },
  {
    /* 🔥 SMART CACHE */
    condition: (_, { getState }) => {
      try {
        const state = getState();
        const { lastFetched } = state.admin?.tournaments || {};

        const FIVE_MINUTES = 5 * 60 * 1000;

        // ❌ Skip API if cached
        if (lastFetched && Date.now() - lastFetched < FIVE_MINUTES) {
          return false;
        }

        return true;
      } catch {
        return true;
      }
    },
  }
);

